import { MenuItem, Select, SelectChangeEvent, SxProps, Theme } from '@mui/material';

import { Location_Metrics_Mobile_Pay_Filter } from '@occc/graphql';

import { TRANSACTION_SET_OPTIONS } from './transaction-set-selector.constants';
import {
  TransactionSetSelectorProps,
  TransactionSetSelectorVariant,
} from './transaction-set-selector.types';

const variantStyles: Record<TransactionSetSelectorVariant, SxProps<Theme>> = {
  default: {
    minWidth: 180,
  },
  onDark: {
    minWidth: 180,
    color: 'common.white',
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255, 255, 255, 0.5)',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'common.white',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'common.white',
    },
    '.MuiSvgIcon-root': {
      color: 'common.white',
    },
  },
};

export const TransactionSetSelector = ({
  value,
  onChange,
  variant = 'default',
}: TransactionSetSelectorProps) => {
  const handleChange = (event: SelectChangeEvent<Location_Metrics_Mobile_Pay_Filter>) => {
    onChange(event.target.value as Location_Metrics_Mobile_Pay_Filter);
  };

  return (
    <Select
      data-testid='transaction-set-selector'
      size='small'
      variant='outlined'
      value={value}
      onChange={handleChange}
      sx={variantStyles[variant]}
      SelectDisplayProps={{ 'aria-label': 'Transaction set' }}
    >
      {TRANSACTION_SET_OPTIONS.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};
